module.exports = __webpack_public_path__ + "static/media/Neo-Banking.e8c7dada.png";